export const body = {
    // height: "100vh",
    // display: "flex",
    // flexDirection: "column",
    // justifyContent: "center"
    // position: "relative"
};

export const navButton = {
    backgroundColor: "white",
    marginTop: "5px",
    marginBottom: "5px",
    paddingTop: "5px",
    paddingBottom: "5px",
    paddingRight: "10px",
    paddingLeft: "10px",
    fontSize: "20px",
    borderRadius: "10px 0 0 10px",
    cursor: "pointer",
    width: "220px"
};

export const navButtonSelected = {
    backgroundColor: "blue",
    color: "white",
    marginTop: "5px",
    marginBottom: "5px",
    paddingTop: "5px",
    paddingBottom: "5px",
    paddingRight: "10px",
    paddingLeft: "10px",
    fontSize: "20px",
    fontWeight: "bold",
    borderRadius: "10px 0 0 10px",
    width: "220px"
};

export const navButtonHover = {
    backgroundColor: "white",
    marginTop: "5px",
    marginBottom: "5px",
    paddingTop: "5px",
    paddingBottom: "5px",
    paddingRight: "10px",
    paddingLeft: "10px",
    fontSize: "20px",
    borderRadius: "10px 0 0 10px",
    cursor: "pointer",
    fontWeight: "bold"
};

export const sideNavBar = {
    position: "absolute",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    // border: "1px solid black",
    transition: "all 0.2s ease-out"
};

export const underSideNav = {
    position: "absolute",
    border: "1px solid black",
    // right: "0",
    height: "80vh",
    width: "10vw",
    top: "10vh"
};

export const topNavBar = {
    // position: "absolute",
    height: "30px",
    width: "100vw",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "end"
    // paddingTop: "10px",
    // border: "1px solid black"
    // padding: "10px"
};

export const topBarIcon = {
    color: "white",
    padding: "5px"
    // border: "1px solid black",
    // display: "flex"
    // justifyContent: "center"
};

export const topBar = {
    position: "absolute",
    top: "5px",
    // height: "30px",
    width: "20%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
    // border: "1px solid black"
    // backgroundColor: "red"
};

//mobile nav bar
export const mobileNav_navButton = {
    // position: "absolute",
    height: "50px",
    width: "170px",
    backgroundColor: "white",
    display: "flex",
    justifyContent: "right",
    alignItems: "center",
    paddingRight: "20px"
};

export const mobileNav_navButtonSelected = {
    // position: "absolute",
    height: "50px",
    width: "170px",
    backgroundColor: "blue",
    color: "white",
    fontWeight: "bold",
    display: "flex",
    justifyContent: "right",
    alignItems: "center",
    paddingRight: "20px"
};

export const mobileNav_navBody = {
    position: "absolute",
    top: "50px",
    right: "0",
    borderRadius: "25px"
};
